import React, { useEffect, useState } from "react";
import { Nav } from "../../../../layouts/navbar/nav";
import images from "../../../../constant/images";
import countryList from "country-list";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import {
  storeMembership,
  storeHandicap,
  storeLicense,
  storeSector,
  storeRefereedBy,
  storeCompany,
  storeGolfer,
  storePosition,
  storeClub,
  storeReferredBy,
} from "../../../../formSlice";
import { useTranslation } from "react-i18next";
// import { translate } from "../localization";

export default function StepThree() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");
    const user = localStorage.getItem("user");


  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  // Use browser language for locale
  // const locale = navigator.language.slice(0, 2);

  const [golfer, setGolfer] = useState("Yes");
  const [handicap, setHandicap] = useState(null);
  const [license, setLicense] = useState(null);
  const [licenseMessage, setLicenseMessage] = useState(null);
  const [sector, setSector] = useState("Finance");
  const [specify, setSpecify] = useState(null);
  const [specifyMessage, setSpecifyMessage] = useState(null);
  const [company, setCompany] = useState("");
  const [companyMessage, setCompanyMessage] = useState("");
  const [position, setPosition] = useState("");
  const [positionMessage, setPositionMessage] = useState("");
  const [club, setClub] = useState(null);
  const [clubMessage, setClubMessage] = useState(null);
  const [referred, setReferred] = useState("");
  const [isChecked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editable, setEditable] = useState(true);
  const [enabled, setEnabled] = useState(true);
  const [submission, setSubmission] = useState(false);
  const [error, setError] = useState(null);

  // Example static items; if you have translations, replace these accordingly
  const handicapItems = ["0-8", "9-18", "19-25", "25+"];

  const navigate = useNavigate();
  const form = useSelector((state) => state.gtm.form);
  const dispatch = useDispatch();

  // Function to register user by sending form data

  const registerUser = async () => {
    const formData = new FormData();
    for (const key in form) {
      if (form[key]) {
        formData.append(key, form[key]);
      }
    }

    if (form.picture && form.picture.file instanceof Blob) {
      formData.append("image", form.picture.file, form.picture.name);
    } else {
      console.error("form.picture is not a valid file", form.picture);
    }

    try {
      setIsLoading(true);
      const response = await axios.post(`${baseUrl}/register`, formData, {
        withCredentials: true,
        withXSRFToken: true,
        credentials: "include",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {

        navigate("/verification", {
          state: {
            email: response.data.user.email,
            source: 0,
          },
        });
      } else {

      }
    } catch (error) {
      console.error("Registration error:", error);
      if (error.response) {
        console.error("Error status:", error.response.status);
        console.error("Error data:", error.response.data);
      }
      setError(error.response?.data.message || "An error occurred");
    } finally {
      setIsLoading(false);
      setSubmission(false);
    }
  };
  useEffect(() => {
    if (user) {
      navigate("/home"); // or your desired route
    }
  }, [user, navigate]);

  // This function dispatches the form values to Redux and sets the submission flag.
  const handleSubmit = () => {
    dispatch(storeGolfer(golfer));
    dispatch(storeHandicap(handicap));
    dispatch(storeReferredBy(referred));

    if (sector === "Other") {
      if (specify) {
        dispatch(storeSector(specify));
      } else {
        setSpecifyMessage("Specify your industry.");
      }
    } else {
      dispatch(storeSector(sector));
    }
    if (company) {
      dispatch(storeCompany(company));
    } else {
      setCompanyMessage("Company is required.");
    }
    if (position) {
      dispatch(storePosition(position));
    } else {
      setPositionMessage("Position is required.");
    }
    if (editable && enabled) {
      if (license) {
        dispatch(storeLicense(license));
      } else {
        setLicenseMessage("License number is required.");
      }
      if (club) {
        dispatch(storeClub(club));
      } else {
        setClubMessage("Club is required.");
      }
    }
    if (editable && enabled) {
      if (license && club) {
        setSubmission(true);
      }
    } else {
      if (sector === "Other") {
        if (company && position && specify) {
          setSubmission(true);
        }
      } else {
        if (company && position) {
          setSubmission(true);
        }
      }
    }
  };

  useEffect(() => {
    if (submission) {

      registerUser();
    }
  }, [submission]);

  return (
    <div
      className="flex flex-col gap-12 min-h-screen"
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Nav />
      <div className="flex items-center justify-center w-full px-4 mb-32">
        <div className="bg-white shadow-custom px-6 py-6 sm:px-8 sm:py-8 md:px-12 md:py-10 rounded-xl w-full max-w-[620px] ">
          <h3 className="text-2xl sm:text-3xl mb-6 text-center font-semibold text-black">
            {t("step_one.register")}
          </h3>
          <form
            className="space-y-5 sm:space-y-6"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            {/* Golfer select */}
            <div className="relative w-full">
              {/* <span className="absolute left-[30%] sm:left-[20%] top-1/2 transform -translate-y-1/2 text-1xl text-red-500">
                *
              </span> */}
              <select
                value={golfer}
                onChange={(e) => setGolfer(e.target.value)}
                required
                className="w-full text-gray-400 focus:text-black bg-[#F4F5F9] rounded-xl py-3 px-4 border-none"
              >
                <option value="" disabled hidden>
                  {language === "fr" ? "Golfeur?" : "Golfer?"}
                </option>
                <option value="Yes">
                  {" "}
                  {language === "fr" ? "Oui" : "Yes"}
                </option>
                <option value="No"> {language === "fr" ? "Non" : "No"}</option>
              </select>
            </div>

            {/* Golf club input */}
            <div className="relative w-full">
              <input
                value={club || ""}
                onChange={(e) => setClub(e.target.value)}
                required
                type="text"
                className="w-full bg-[#F4F5F9] rounded-xl py-3 px-4 placeholder-gray-400 border-none focus:ring-0"
                placeholder={t("step_three.golf_club")}
              />
              {clubMessage && (
                <p className="text-red-500 text-xs text-start">{clubMessage}</p>
              )}
            </div>

            {/* Handicap select */}
            <div className="relative w-full">
              <select
                value={handicap || ""}
                onChange={(e) => setHandicap(e.target.value)}
                required
                className="w-full text-gray-400 focus:text-black bg-[#F4F5F9] rounded-xl py-3 px-4 border-none focus:ring-0"
              >
                <option value="" disabled hidden>
                  Handicap
                </option>
                <option value="0-8">0-8</option>
                <option value="9-18">9-18</option>
                <option value="19-25">19-25</option>
                <option value="25+">25+</option>
              </select>
            </div>

            {/* License number */}
            <div className="relative w-full">
              <input
                value={license || ""}
                onChange={(e) => setLicense(e.target.value)}
                required
                type="text"
                className="w-full bg-[#F4F5F9] rounded-xl py-3 px-4 placeholder-gray-400 border-none focus:ring-0"
                placeholder={t("step_three.license_number")}
              />
              {licenseMessage && (
                <p className="text-red-500 text-xs text-start">
                  {licenseMessage}
                </p>
              )}
            </div>

            {/* Industry select */}
            <div className="relative w-full">
              <select
                value={sector || ""}
                onChange={(e) => setSector(e.target.value)}
                required
                className="w-full text-gray-400 focus:text-black bg-[#F4F5F9] rounded-xl py-3 px-4 border-none focus:ring-0"
              >
                <option value="" disabled hidden>
                  {language === "fr" ? "Secteur" : "Industry"}
                </option>
                <option value="Finance">Finance</option>
                <option value="Technology">
                  {language === "fr" ? "Technologie" : "Technology"}
                </option>
                <option value="Healthcare">
                  {language === "fr" ? "Santé" : "Healthcare"}
                </option>
                <option value="Other">
                  {language === "fr" ? "Autre" : "Other"}
                </option>
              </select>
            </div>

            {/* Show input if "Other" is selected */}
            {sector === "Other" && (
              <div className="relative w-full mt-2">
                <input
                  value={specify || ""}
                  onChange={(e) => setSpecify(e.target.value)}
                  required
                  type="text"
                  className="w-full bg-[#F4F5F9] rounded-xl py-3 px-4 placeholder-gray-400 border-none focus:ring-0"
                  placeholder={language === "fr" ? "Spécifiez votre secteur" : "Specify your industry"}
                />

                {console.log(specify)}

                {specifyMessage && (
                  <p className="text-red-500 text-xs text-start">{specifyMessage}</p>
                )}
              </div>
            )}
            <div className="relative w-full">
              <input
                value={company || ""}
                onChange={(e) => setCompany(e.target.value)}
                required
                type="text"
                className="w-full bg-[#F4F5F9] rounded-xl py-3 px-4 placeholder-gray-400 border-none focus:ring-0"
                placeholder={t("step_three.company_name")}
              />
              {companyMessage && (
                <p className="text-red-500 text-xs text-start">
                  {companyMessage}
                </p>
              )}
            </div>

            {/* Your position */}
            <div className="relative w-full">
              <input
                value={position || ""}
                onChange={(e) => setPosition(e.target.value)}
                required
                type="text"
                className="w-full bg-[#F4F5F9] rounded-xl py-3 px-4 placeholder-gray-400 border-none focus:ring-0"
                placeholder={t("step_three.your_position")}
              />
              {positionMessage && (
                <p className="text-red-500 text-xs text-start">
                  {positionMessage}
                </p>
              )}
            </div>

            {/* Recommandé par */}
            <div>
              <label className="font-bold text-sm block mb-1">
                {t("step_three.full_name_warning")}
              </label>
              <input
                value={referred || ""}
                onChange={(e) => setReferred(e.target.value)}
                required
                type="text"
                className="w-full bg-[#F4F5F9] rounded-xl py-3 px-4 placeholder-gray-400 border-none focus:ring-0"
                placeholder={t("step_three.recommended_by")}
              />
            </div>

            {/* Checkbox for Terms */}
            <div className="flex items-start gap-3 mt-4">
              <input
                checked={isChecked}
                onChange={() => setChecked(!isChecked)}
                required
                type="checkbox"
                className="w-5 h-5 accent-black"
              />
              <p className="text-xs text-gray-400">
                {language === "fr"
                  ? "J'ai lu et j'accepte"
                  : "I have read and I accept the"}{" "}
                <NavLink
                  to="termes-et-conditions"
                  className="text-black font-semibold hover:underline"
                >
                  {language === "fr"
                    ? "les Conditions générales"
                    : "Terms and Conditions"}
                </NavLink>
                ,{" "}
                <NavLink
                  to="/conditions-de-notification"
                  className="text-black font-semibold hover:underline"
                >
                  {language === "fr"
                    ? "les Conditions de notification"
                    : "Notification Conditions"}
                </NavLink>
                , {language === "fr" ? "et" : "and"}{" "}
                <NavLink
                  to="/conditions-de-paiement"
                  className="text-black font-semibold hover:underline"
                >
                  {language === "fr"
                    ? "les Conditions de paiement"
                    : " Payment Conditions"}
                </NavLink>{" "}
                {language === "fr" ? "ainsi que" : " and"}{" "}
                <NavLink
                  to="politique-de-confidentialite"
                  className="text-black font-semibold hover:underline"
                >
                  {language === "fr"
                    ? "la Politique de confidentialité."
                    : " Privacy Policy."}
                </NavLink>
              </p>
            </div>

            {/* Submit button */}
            <div>
              <button
                type="submit"
                disabled={isLoading || !isChecked}
                className={`w-full sm:max-w-[350px] py-3 text-base rounded-[33px] font-semibold border-none mx-auto block ${
                  isChecked && !isLoading
                    ? "bg-black cursor-pointer hover:bg-[#333] text-white"
                    : "bg-gray-400 cursor-not-allowed pointer-events-none"
                }`}
              >
                {isLoading
                  ? "Loading..."
                  : `${language === "fr" ? "Suivant" : "Next"}`}
              </button>
            </div>
          </form>

          {/* Footer info */}
          {/* <div className="text-[7px] xs:text-xs sm:text-[12px] text-center text-[#666] pt-[40px]">
              {t("login.help_message")} <br className="hidden xs:block" />
              {language === "fr" ? "Voir les" : "See the"}{" "}
              <NavLink
                to="/termes-et-conditions"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions d'utilisation"
                  : "Terms of Use"}
              </NavLink>
              ,{" "}
              <NavLink
                to="/conditions-de-notification"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions de notification"
                  : "Notification conditions"}
              </NavLink>
              ,{" "}
              <NavLink
                to="/conditions-de-paiement"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions de paiement"
                  : "Payment conditions"}
              </NavLink>
              {language === "fr" ? ", et la" : ", and"}{" "}
              <NavLink
                to="/politique-de-confidentialite"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "politique de confidentialité"
                  : "Privacy Policy"}
              </NavLink>
              .
            </div> */}
        </div>
      </div>
    </div>
  );
}
